import { Download01 } from "@untitledui/icons";
import { Table, TableCard } from "@/components/application/table/table";
import { Button } from "@/components/base/buttons/button";
import type { SummaryRow } from "../flag-qa-types";
import { QUALITY_BAND_COLORS } from "../flag-qa-types";
import { getQualityBand } from "../flag-qa-utils";

interface FlagQaSummaryTableProps {
  title: string;
  summary: SummaryRow[];
  onExport?: () => void;
  exportLabel?: string;
}

export function FlagQaSummaryTable({
  title,
  summary,
  onExport,
  exportLabel = "Download CSV",
}: FlagQaSummaryTableProps) {
  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-primary">{title}</h3>
        {onExport && (
          <Button size="sm" onClick={onExport} className="flex items-center gap-2">
            <Download01 className="size-4" />
            {exportLabel}
          </Button>
        )}
      </div>
      <TableCard.Root>
        <div className="overflow-x-auto">
          <Table>
            <Table.Header>
              <Table.Head id="category" label="Category" isRowHeader />
              <Table.Head id="total" label="Total" />
              <Table.Head id="fp" label="FP" />
              <Table.Head id="tp" label="TP" />
              <Table.Head id="fn" label="FN" />
              <Table.Head id="accuracy" label="Accuracy %" />
              <Table.Head id="recall" label="Recall %" />
              <Table.Head id="precision" label="Precision %" />
              <Table.Head id="f1" label="F1 %" />
            </Table.Header>
            <Table.Body items={summary}>
              {(row) => (
                <Table.Row id={row.category}>
                  <Table.Cell>{row.category}</Table.Cell>
                  <Table.Cell>{row.total}</Table.Cell>
                  <Table.Cell>{row.fp}</Table.Cell>
                  <Table.Cell>{row.tp}</Table.Cell>
                  <Table.Cell>{row.fn}</Table.Cell>
                  <Table.Cell>{row.accuracy.toFixed(1)}</Table.Cell>
                  <Table.Cell>{row.recall.toFixed(1)}</Table.Cell>
                  <Table.Cell>{row.precision.toFixed(1)}</Table.Cell>
                  <Table.Cell>
                    <span style={{ color: QUALITY_BAND_COLORS[getQualityBand(row.f1)], fontWeight: 700 }}>
                      {row.f1.toFixed(1)}
                    </span>
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        </div>
      </TableCard.Root>
    </div>
  );
}
